import {Component, Input, OnInit} from '@angular/core';
import {ProductSummaryModel} from "../../entity/productSummary.model";

@Component({
    selector: 'app-product-summary-field',
    templateUrl: './product-summary-field.component.html'
})
export class ProductSummaryFieldComponent implements OnInit {

    @Input() entity: ProductSummaryModel;

    constructor() {
    }

    ngOnInit() {
    }

}
